export default "__VITE_ASSET__XgHeUb9u__"